import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";
import zIndexes from "zIndexes.module.scss";

export const useStyles = makeStyles((theme) => ({
  rootContainerMobileMenuVisible: {
    position: "absolute",
    width: "100%",
    left: "0px",
    zIndex: zIndexes.eventDirectorySwitcherZIndex,
  },
  rootContainerMobilePresentationModeMenuVisible: {
    position: "absolute",
    width: "100%",
    left: "0px",
  },
  container: {
    marginLeft: "10px",
    marginTop: "4px",
    marginBottom: "4px",
    padding: "4px 10px",
    width: "400px",
    userSelect: "none",
    cursor: "pointer",
    height: "53px",
  },
  containerPresentationMode: {
    marginLeft: "0px",
    backgroundColor: "#2C2F3C", // to add to palette
    border: "1px solid #333544",
  },
  containerMenuVisible: {
    borderRadius: "0",
    borderTopLeftRadius: "5px",
    borderTopRightRadius: "5px",
  },
  containerMobile: {
    display: "flex",
    border: 0,
    margin: 0,
    height: "100%",
    width: "auto",
  },
  containerMobilePresentationMode: {
    height: 40,
    marginLeft: "0px",
    backgroundColor: "#2C2F3C",
    border: 0,
    borderRadius: 0,
  },
  containerMobileMenuVisible: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  containerMobilePresentationMenuVisible: {
    borderRadius: 0,
  },
  preview: {
    marginLeft: "0px",
    marginTop: "0px",
    marginBottom: "0px",
  },
  innerContainer: {
    display: "flex",
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px 8px",
    borderRadius: "50%",
    aspectRatio: "1",
    width: "36px",
    fontSize: "22px",
    height: "36px",
    backgroundColor: theme.palette.events.blueSecondary,
    color: theme.palette.white,
    marginRight: "10px",
  },
  iconMobile: {
    display: "none",
  },
  directoryName: {
    color: theme.palette.events.blueSecondary,
    lineHeight: "19px",
    fontWeight: 500,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    width: "220px",
  },
  directoryNamePresentationMode: {
    color: theme.palette.white,
    opacity: 0.7,
  },
  directoryNameMobile: {
    fontSize: "12px",
    lineHeight: "14px",
    width: "calc(85vw - 200px)",
  },
  eventName: {
    color: theme.palette.events.textPrimary,
    lineHeight: "22px",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    width: "220px",
  },
  eventNamePresentationMode: {
    color: theme.palette.white,
    opacity: 0.9,
  },
  eventNameMobile: {
    fontSize: "14px",
    lineHeight: "18px",
    width: "calc(85vw - 200px)",
  },
  textMobilePresentation: {
    width: "calc(80vw - 200px)",
  },
  textMobileMenuVisible: {
    width: "60vw",
  },
  button: {
    width: "131px",
    height: "36px",
    border: 0,
    padding: "8px 0px",
  },
  buttonPresentationMode: {
    backgroundColor: "#313440",
  },
  buttonContent: {
    whiteSpace: "nowrap",
    fontSize: "14px",
  },
  buttonContentPresentationMode: {
    color: theme.palette.white,
    opacity: 0.9,
    fontWeight: 500,
  },
  buttonArrow: {
    marginLeft: "10px",
  },
  contentWrapperClassName: {
    padding: 0,
  },
}));
